<template>
  <div>
    <div class="page-header">
		<div class="add-item d-flex">
			<div class="page-title">
				<h4>{{ $t("item_color") }}</h4>
			</div>
		</div>
<!--		<ul class="table-top-head">-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--      </li>-->
<!--      <li>-->
<!--        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--      </li>-->
<!--		</ul>-->
		<div v-if="can('inventory.measurement_units', 'W')" class="page-btn">
			<!-- Trigger Button for Modal -->
			<a href="#" class="btn btn-added" data-bs-toggle="modal" data-bs-target="#create-modal">
				<i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_item_color") }}
			</a>
			<!-- Modal Component -->
			<CreateModal
				id="create-modal" @create_success="fetchItemColors"
			/>
		</div>
	</div>
	<!-- /product list -->
	<div class="card table-list-card">
		<div class="card-body">

			<div class="table-responsive">
				<DataTable v-if="item_colors.length" :tableId="'itemColorTable'">
					<thead>
						<tr>
							<th>{{ $t("item_color") }}</th>
							<th class="no-sort">{{ $t("action") }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in item_colors" :key="item.id">
							<td>{{ item.color }}</td>
							<td class="action-table-data">
                <div v-if="can('inventory.measurement_units', 'E')" class="edit-delete-action">
                  <a class="me-2 p-2" href="#" @click.prevent="openEditModal(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ti ti-edit">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                  </a>
                </div>
							</td>
						</tr>
					</tbody>
				</DataTable>
        <!-- If No Data -->
        <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
            <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
          </svg>
          <h5 class="text-muted">No Data Found</h5>
          <p class="text-secondary small">Try adjusting filters or add new data.</p>
        </div>

				<EditModal id="edit-modal" :selectedItemColor="selectedItemColor" @edit_success="fetchItemColors" />
			</div>
		</div>
	</div>
<!-- /product list -->

  </div>
</template>

<script>
import { can as canAccess } from "@/helpers/permission";
import CreateModal from '@/views/admin_dashboard/item_color/CreateModal.vue';
import EditModal from '@/views/admin_dashboard/item_color/EditModal.vue';
import apiUrls from '../../../urls';
import DataTable from '@/components/common/DataTable.vue';

export default {
  inject: ['globalLoading'],
  components: {
    CreateModal,
    EditModal,
    DataTable,
  },
  data() {
    return {
      item_colors: [], // Store fetched item_colors
	    selectedItemColor: {}
    };
  },
  methods: {
	  openEditModal(color) {
			this.selectedItemColor = color;
			this.$nextTick(() => {
			const modal = new bootstrap.Modal(document.getElementById('edit-modal'));
			modal.show();
      });
    },
	async fetchItemColors() {
	    this.globalLoading(true)
      try {
        const response = await this.$axios.get(apiUrls.item_color.get);
        this.item_colors = response.data;
      } catch (error) {
        console.error("Error fetching item color:", error);
      } finally {
        this.globalLoading(false)
      }
    },

    can(code, requiredLevel) {
      return canAccess(code, requiredLevel);
    },
  },
  created() {
    this.fetchItemColors();
  },
};
</script>
